<template>
    <SelectPlan v-if="name === 'SelectPlan'" />
    <Binoculars v-else-if="name === 'Binoculars'" />
    <Chatbot v-else-if="name === 'Chatbot'" />
    <CreditCard v-else-if="name === 'CreditCard'" />
    <Instagram v-else-if="name === 'Instagram'" />
    <Vector v-else-if="name === 'Vector'" />
    <Whatsapp v-else-if="name === 'Whatsapp'" />
    <CChatbot v-else-if="name === 'CChatbot'" />
    <CInstagram v-else-if="name === 'CInstagram'" />
    <div class="whatsapp-business-billing-svg" v-else-if="name === 'CWhatsappBusiness'">
        <WhatsappBusinessIcon />
    </div>
    <div class="whatsapp-billing-svg" v-else-if="name === 'CWhatsapp'">
        <WhatsappIcon />
    </div>
    <CSupsis v-else-if="name === 'CSupsis'" />
    <Alipay v-else-if="name === 'Alipay'" />
    <Amex v-else-if="name === 'Amex'" />
    <Diners v-else-if="name === 'Diners'" />
    <Maestro v-else-if="name === 'Maestro'" />
    <MasterCard v-else-if="name === 'Mastercard'" />
    <Visa v-else-if="name === 'Visa'" />
    <AppSumo v-else-if="name === 'AppSumo'" />
    <MessengerIcon v-else-if="name === 'Messenger'" />
    <TrendyolIcon v-else-if="name === 'trendyol'" />
    <MetaIcon v-else-if="name === 'MetaIcon'" />
    <CustomerTables v-else-if="name === 'CustomerTables'" />
    <ChatBotNew v-else-if="name === 'ChatbotNew'" />
    <FormSvg v-else-if="name === 'Form'" />
    <AutomationSvg v-else-if="name === 'Automation'" />
    <MailSvg v-else-if="name === 'Mail'" />
    <TaskSvg v-else-if="name === 'Tasks'" />
    <WhatsappBusinessNew v-else-if="name === 'WhatsappBusinessNew'" />
    <WebhookIntegration v-else-if="name === 'WebhookIntegration'" />
    <AIAssistant v-else-if="name === 'ArtificialIntelligence'" />
    <TelegramEntegration v-else-if="name === 'TelegramEntegration'" />
    <LinkedinIcon v-else-if="name === 'LinkedinEntegration'" />
    <CAiVoice v-else-if="name === 'CAiVoice'" />
    <WebphoneIcon v-else-if="name === 'WebphoneIcon'" />
</template>

<script>
import Binoculars from "./svg/stepper/Binoculars.vue";
import Chatbot from "./svg/stepper/Chatbot.vue";
import CreditCard from "./svg/stepper/CreditCard.vue";
import Instagram from "./svg/stepper/Instagram.vue";
import SelectPlan from "./svg/stepper/SelectPlan.vue";
import Vector from "./svg/stepper/Vector.vue";
import Whatsapp from "./svg/stepper/Whatsapp.vue";
import CChatbot from "./svg/payment/CChatbot.vue";
import CInstagram from "./svg/payment/CInstagram.vue";
import CSupsis from "./svg/payment/CSupsis.vue";
import Alipay from "./svg/creditCard/Alipay.vue";
import Amex from "./svg/creditCard/Amex.vue";
import Diners from "./svg/creditCard/Diners.vue";
import Maestro from "./svg/creditCard/Maestro.vue";
import MasterCard from "./svg/creditCard/MasterCard.vue";
import PayPal from "./svg/creditCard/PayPal.vue";
import Visa from "./svg/creditCard/Visa.vue";
import WhatsappBusinessIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import WhatsappIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import AppSumo from "./svg/AppSumo.vue";
import MessengerIcon from "../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import TrendyolIcon from "../views/Pages/Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import MetaIcon from "../views/Pages/Chatbot/pages/integrations/svg/MetaIcon.vue";
import CustomerTables from "./svg/CustomerTables.vue";
import ChatBotNew from "./svg/ChatBotNew.vue";
import FormSvg from "./svg/Form.vue";
import AutomationSvg from "./svg/AutomationSvg.vue";
import TaskSvg from "./svg/TaskSvg.vue";
import MailSvg from "./svg/MailSvg.vue";
import WhatsappBusinessNew from "./svg/WhatsappBusinessNew.vue";
import WebhookIntegration from "../views/Pages/Billing/components/svg/features/WebhookIntegration.vue";
import AIAssistant from "../views/Pages/Billing/components/svg/features/AIAssistant.vue";
import TelegramEntegration from "../views/Pages/Billing/components/svg/features/TelegramEntegration.vue";
import LinkedinIcon from "../views/Pages/Chatbot/pages/integrations/svg/LinkedinIcon.vue";
import CAiVoice from "./svg/payment/CAiVoice.vue";
import WebphoneIcon from "./svg/WebphoneIcon.vue";
export default {
    name: "DynamicSvg",
    props: ["name"],
    components: {
        LinkedinIcon,
        TelegramEntegration,
        AIAssistant,
        WebhookIntegration,
        WhatsappBusinessNew,
        MailSvg,
        TaskSvg,
        AutomationSvg,
        FormSvg,
        ChatBotNew,
        CustomerTables,
        MetaIcon,
        TrendyolIcon,
        MessengerIcon,
        Binoculars,
        Chatbot,
        CreditCard,
        SelectPlan,
        Vector,
        Instagram,
        Whatsapp,
        CSupsis,
        CChatbot,
        CInstagram,
        Alipay,
        Amex,
        Diners,
        Maestro,
        MasterCard,
        PayPal,
        Visa,
        WhatsappBusinessIcon,
        WhatsappIcon,
        AppSumo,
        CAiVoice,
        WebphoneIcon
    },
};
</script>
<style>
.whatsapp-billing-svg svg,
.whatsapp-business-billing-svg svg {
    width: 100%;
    height: 100%;
}

.whatsapp-billing-svg svg path {
    fill: #58ca64 !important;
}
.whatsapp-business-billing-svg svg path[stroke-linejoin="round"] {
    stroke: #58ca64 !important;
}
</style>
